export default __webpack_public_path__ + "images/logo192.png?64b6abdbeb9a1690d34cd101de8cc440";